import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logo/logo_emblem_2nd_en.svg")